import React, { useContext, useEffect, useState } from "react";
import _ from 'lodash';
import Router from 'next/router';
import * as workerTimers from 'worker-timers'
import TimeOut from '../../../../components/Modal/TimeOut';


const RegistrationTimer = ({ url, openPaymentModal, className, query, selectedTickets, eventDetails}) => {
    // const isPrakashEvent = url.includes("https://konfhub.com/checkout/prakarsh23") ? true : false;
    // const isTenMinutesTimer = eventDetails.event_id === "14c59dba-83bc-499b-a486-a9ea4d6ea707" ? true : false
    // const isFifteenMinutesTimer = (eventDetails.event_id === "2f1ee471-4148-48da-9cf9-2b3d2090b415" || eventDetails.event_id === "75f3ed69-6173-45da-907d-1bba5f3ec74a") ? true : false;
    // const isTwentyMinutesTimer = eventDetails.event_id === "8c00365a-a23d-4356-8b56-13b34297fd18" ? true : false
    const checkoutTime = eventDetails.first_ticket_timer
    const additionalTime = eventDetails.additional_ticket_timer
    const initialMinute = checkoutTime ? checkoutTime : 5, initialSeconds = 0;
    const [minutes, setMinutes] = useState(initialMinute);
    const [seconds, setSeconds] = useState(initialSeconds);
    const [isOpen, setOpen] = useState(false);

    useEffect(() => {
        let myInterval = workerTimers.setInterval(() => {
            if (openPaymentModal) return;
            if (seconds > 0 && !openPaymentModal) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0 && !openPaymentModal) {
                if (minutes === 0) {
                    setOpen(true)
                    clearInterval(myInterval)
                } else {
                    setMinutes(minutes - 1);
                    setSeconds(59);
                }
            }
        }, 1000)
        return () => {
            workerTimers.clearInterval(myInterval);
        };
    });

    useEffect(() => {
        if(selectedTickets && !_.isEmpty(selectedTickets)) {
            let tot = 0;
            selectedTickets.map(ticketObj => tot = tot + ticketObj.totalSelected)
            let newMinutes = checkoutTime ? checkoutTime + (additionalTime*(tot-1)) : 5 + (2*(tot-1))
            // let newMinutes = isTenMinutesTimer ? 10 + (5*(tot-1)) : isFifteenMinutesTimer ? 15 + (5*(tot-1)) : isTwentyMinutesTimer ? 20 + (5*(tot-1)) : 5 + (2*(tot-1))
            setMinutes(newMinutes)
        }
    }, [selectedTickets])

    return (
        <>
            <div className="timer-modal">
                <TimeOut url={url} isOpen={isOpen} />
            </div>

            <div className={className ? className : `d-flex justify-content-end align-items-center timer-count px-2`}>
                {/* <img src="/img/checkout/registration-timer.svg" /> */}
                <RegistrationTimerIcon query={query} />
                <p className='m-0 d-inline timer-badge'>&nbsp;Time Left: {minutes}:{seconds < 10 ?  `0${seconds}` : seconds}</p>
                <style>{`
                    .timer-count {
                        height: 30px;
                        background: ${query.inputErrCl ? `#${query.inputErrCl}` : "#FF0000"};
                        color: white;
                        border-radius: 25px;
                    }
                    @media (max-width: 768px){
                        .timer-count {
                            background: ${query.inputErrCl ? `#${query.inputErrCl}` : "#FF0000"};
                            border-radius: 0px;
                            position : fixed;
                            width: 100%;
                            z-index: 10;   
                        }

                    }
                `}</style>
            </div>

        </>
    )
}

export default RegistrationTimer;


const RegistrationTimerIcon = ({query}) => {
    return (
        <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 17.042C7.44248 17.042 5.91992 16.5801 4.62489 15.7148C3.32985 14.8495 2.32049 13.6196 1.72445 12.1806C1.12841 10.7417 0.972461 9.15826 1.27632 7.63066C1.58018 6.10306 2.3302 4.69987 3.43154 3.59853C4.53288 2.49719 5.93607 1.74717 7.46367 1.44331C8.99127 1.13945 10.5747 1.2954 12.0136 1.89144C13.4526 2.48748 14.6825 3.49684 15.5478 4.79188C16.4131 6.08692 16.875 7.60947 16.875 9.167C16.875 11.2556 16.0453 13.2586 14.5685 14.7355C13.0916 16.2123 11.0886 17.042 9 17.042ZM9 2.417C7.66498 2.417 6.35994 2.81288 5.2499 3.55458C4.13987 4.29627 3.27471 5.35048 2.76382 6.58388C2.25293 7.81728 2.11925 9.17448 2.3797 10.4839C2.64015 11.7932 3.28303 12.996 4.22703 13.94C5.17104 14.884 6.37377 15.5268 7.68314 15.7873C8.99252 16.0477 10.3497 15.9141 11.5831 15.4032C12.8165 14.8923 13.8707 14.0271 14.6124 12.9171C15.3541 11.8071 15.75 10.502 15.75 9.167C15.75 7.37678 15.0388 5.65989 13.773 4.39402C12.5071 3.12815 10.7902 2.417 9 2.417Z" fill="white"/>
            <path d="M11.5819 12.542L8.4375 9.39762V4.10449H9.5625V8.93074L12.375 11.7489L11.5819 12.542Z" fill="white"/>
        </svg>
    )
}